import React from 'react';
import KYCBaseContainer from '@alphapoint/apex-web/lib/components/KYC';
import KYCSumSubLevelsContainer from './KYCSumSubLevelsContainer';

const KYCSumSubComponent = () => {
  return <KYCBaseContainer LevelsComponent={KYCSumSubLevelsContainer} />;
};

export default KYCSumSubComponent;
